import { ConfigBlockState } from '../WidgetBlocks/types/IWidgetBlock';

interface Params<T> {
    datasets: T[];
    viewblockState: ConfigBlockState | null;
}

const reduceDatasetsByViewblockState = <T extends { datasetId?: string | null } | null>({ datasets, viewblockState }: Params<T>) => {
    if (!viewblockState?.databilities) {
        return datasets;
    }

    const datasetIds = viewblockState.databilities.map(({ datasetId }) => datasetId);

    return datasets.filter((dataset) => (dataset?.datasetId ? datasetIds.includes(dataset.datasetId) : false)) as T[];
};

export default reduceDatasetsByViewblockState;
